import { render, staticRenderFns } from "./PsychResult.vue?vue&type=template&id=9c9c3542&scoped=true&"
import script from "./PsychResult.vue?vue&type=script&lang=js&"
export * from "./PsychResult.vue?vue&type=script&lang=js&"
import style0 from "./PsychResult.vue?vue&type=style&index=0&id=9c9c3542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c3542",
  null
  
)

export default component.exports